<template>
  <div
    class="modal theme-modal fade show"
    style="display: block; padding-right: 15px;"
    aria-modal="true"
    role="dialog"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="border modal-content">
        <div class="top-0 z-1 position-absolute me-3 mt-3 end-0">
          <button
            class="d-flex flex-center transition-base btn-close btn btn-sm btn-circle"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="handleSensorClose"
          />
        </div>

        <div class="bg-body-tertiary py-3 ps-4 pe-6 rounded-top-3">
          <h4
            id="staticBackdropLabel"
            class="mb-1"
          >
            센서 설정
          </h4>
        </div>

        <div class="px-card pt-1 pb-card modal-body fs--1">
          <div class="mt-3 media">
            <div class="media-body">
              <div class="text-800 fs--1">
                <div class="d-flex align-items-center modal_div">
                  <h6 class="me-2 mb-0 device-title">
                    센서명
                  </h6>
                  <input
                    id="input-setinterval"
                    v-model="setsensor.sname"
                    class="form-control"
                    type="text"
                    placeholder=""
                    style="width:100%"
                  >
                </div>

                <div class="d-flex align-items-center modal_div">
                  <h6 class="me-2 mb-0 device-title">
                    Protocol
                  </h6>
                  <input
                    id="input-setinterval"
                    v-model="setsensor.protocol"
                    class="form-control"
                    type="text"
                    placeholder=""
                    style="width:100%"
                  >
                </div>

                <div class="d-flex align-items-center modal_div">
                  <h6 class="me-2 mb-0 device-title">
                    단위
                  </h6>
                  <input
                    id="input-setinterval"
                    v-model="setsensor.unit"
                    class="form-control"
                    type="text"
                    placeholder=""
                    style="width:100%"
                  >
                </div>

                <div class="d-flex align-items-center modal_div">
                  <h6 class="me-2 mb-0 device-title">
                    소수점
                  </h6>
                  <input
                    id="input-setinterval"
                    v-model="setsensor.dpoint"
                    class="form-control"
                    type="text"
                    placeholder=""
                    style="width:100%"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <a
            class="btn btn-falcon-default btn-sm"
            @click="handleSave"
          >
            <span
              class="mr-2 fs--2"
              data-fa-i2svg=""
            />저장
          </a>
          <a
            class="btn btn-falcon-default btn-sm"
            @click="handleSensorClose"
          >
            <span
              class="mr-2 fs--2"
              data-fa-i2svg=""
            />취소
          </a>
        </div>
      </div>
    </div>
  </div>

  <AlertModal ref="alertModalRef" />
</template>

<script setup lang="ts">

import type { Sensor} from '@/types/commontypes'
import AlertModal from "@/components/AlertModal.vue";

const setsensor = defineModel<Sensor>('setsensor', {required: true})
const emit = defineEmits(['sensor-close', 'sensor-save'])

// const props = defineProps<{
//     setsensor: Sensor;
// }>();


const handleSensorClose = () => {
    emit('sensor-close')
}

const handleSave = () => {
  emit('sensor-save')
}

</script>

<style lang="">
    
</style>